import "../../../chunk-FDX44TNG.js";
import { useEffect } from "react";
const useDidMount = (callback) => {
  useEffect(callback, []);
  return null;
};
export {
  useDidMount
};
//# sourceMappingURL=useDidMount.js.map